import React, { Component } from "react"

import classNames from "classnames/bind"
import styles from "../styles/Question.module.scss"

import { connect } from "react-redux"
import Slider from "react-slick"

import QuestionTemplate from "./Questions/QuestionTemplate"
import Gauge from "./Questions/Gauge"
import { setEntranceTime } from "../store/general"

class Question extends Component {
  state = {
    currentIndex: 0,
  }

  sliderRef = React.createRef()

  goToNext = () => {
    this.sliderRef.slickNext()
  }

  componentDidMount() {
    const { dispatch } = this.props

    dispatch(setEntranceTime())
  }

  render() {
    const { currentIndex } = this.state

    const sliderSetting = {
      arrows: false,
      dots: false,
      draggable: false,
      infinite: false,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      beforeChange: (current, next) => this.setState({ currentIndex: next }),
    }

    return (
      <div className={cn("contents")}>
        <Gauge currentIndex={currentIndex} />
        <Slider {...sliderSetting} ref={(slider) => (this.sliderRef = slider)}>
          {qList.map((item, index) => (
            <QuestionTemplate key={index} qIndex={item} goToNext={this.goToNext} />
          ))}
        </Slider>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  answer: state.general.answer,
})

const cn = classNames.bind(styles)
const qList = [0, 3, 6, 9, 1, 4, 7, 10, 2, 5, 8, 11]

export default connect(mapStateToProps)(Question)
